<template>
    <div class="nav"
         :style="styles">
        <div class="tabs">            
            <template v-for="tab in dataTabs">
                <button class="tab"
                        :class="{active: tab.value === val.value}"
                        :key="tab.value"
                        :disabled="tab.disabled"
                        @click="$emit('input', tab)">
                    {{tab.label}}
                </button>
                <div class="border"
                     :key="'border-' + tab.value"></div>
            </template>
        </div>

        <slot name="heading"></slot>

        <slot name="controls"></slot>
    </div>
</template>

<script>
import vModel from '@mixins/v-model'

export default {
    props: {
        dataTabs: {
            type: Array,
            required: true
        },

        dataPadding: {
            type: String,
        },
        isEdit: {
            type: Boolean
        }
    },

    computed: {
        styles() {
            return {
                padding: this.dataPadding,
            }
        }
    },

    methods: {
        emitBack() {
            this.$emit("back");
        },
    },

    mixins: [vModel]
}
</script>

<style lang="scss" scoped>
@import "~@variables";

.nav {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 2px solid $grey-2;
    width: 90%;
    padding-top: 20px;

    .tabs {
        display: flex;
        margin-bottom: -2px;

        #backButton {
            font-size: 30px;
            margin-right: 15px;
        }

        .border:not(:last-child) {
            border-right: 1px solid $grey-2;
            margin: 8px 0;
        }

        .tab {
            padding: 10px 20px;
            border-bottom: 4px solid transparent;

            &:not(:first-child) {
                margin-left: 2px;
            }

            &:not(:last-child) {
                margin-right: 2px;
            }

            &.active {
                border-bottom: 4px solid $green;
            }
        }
    }
}
</style>
